import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { discountsApi } from '../api/discounts-api';

import { discountKeys } from './discount-keys';

export const CODES_LIMIT = 20;

export interface DiscountCodesFilter {
  q: string;
  isActive: boolean | undefined;
  cursor: string | undefined;
}

/** One page of a discount's codes, newest first; `q` matches part of a code. */
export function useDiscountCodes(storeId: string, id: string, filter: DiscountCodesFilter) {
  const params = {
    limit: CODES_LIMIT,
    ...(filter.q ? { q: filter.q } : {}),
    ...(filter.isActive !== undefined ? { isActive: filter.isActive } : {}),
    ...(filter.cursor ? { cursor: filter.cursor } : {}),
  };
  return useQuery({
    queryKey: discountKeys.codes(storeId, id, params),
    queryFn: () => discountsApi.codes(storeId, id, params),
    placeholderData: keepPreviousData,
  });
}
